
export abstract class BaseDialog<TData, TResponse> {
}
